// extracted by mini-css-extract-plugin
export var tilesList = "tilesList-module--tilesList--1tr5C";
export var jsAnimInit = "tilesList-module--jsAnimInit--1qr3c";
export var tilesListWrap = "tilesList-module--tilesListWrap--1gEBg";